export default __webpack_public_path__ + "static/media/Throw_Button.94da871b.png";